<template>
  <generic-modal
    size="large"
    :title="$t('quotation')"
    icon="file alternate"
    image="/images/icons/quotation.png"
    v-on:destroy="destroy"
    v-bind:on_finished="this.finished"
    :scrolling="true"
    :footer_buttons="footer_buttons"
  >
    <div class="description">
      <div class="ui four item top attached tabular menu" ref="tabs">
        <a class="active item" data-tab="general">
          <i class="info circle icon"></i>
          {{ $t("general info") }}
        </a>
        <a class="item" data-tab="products">
          <i class="cubes icon"></i>
          {{ $t("products") }}
        </a>
        <a class="item" data-tab="custom">
          <i class="font icon"></i>
          {{ $t("custom content") }}
        </a>
        <a class="item" data-tab="preview">
          <i class="eye icon"></i>
          {{ $t("preview") }}
        </a>
      </div>
      <div class="ui bottom attached active tab segment" data-tab="general">
        <general
          :quotation_in="quotation_in"
          :setup="quotation_setup"
          ref="general"
        />
      </div>
      <div class="ui bottom attached tab segment" data-tab="products">
        <products :quotation_in="quotation_in" ref="products" />
      </div>
      <div class="ui bottom attached tab segment" data-tab="custom">
        <custom-content
          :quotation_in="quotation_in"
          :setup="quotation_setup"
          ref="custom_content"
          @update_custom="update_custom"
        />
      </div>
      <div class="ui bottom attached tab segment" data-tab="preview">
        <preview
          :quotation_in="quotation_in"
          :setup="quotation_setup"
          ref="preview"
          @update_preview="update_preview"
        />
      </div>
    </div>
  </generic-modal>
</template>

<script>
import { local_api, stringify, error_toast } from "@/utils";
import filters from "@/filters";
import { cloneDeep } from "lodash";
import GenericModal from "@/components/GenericModal";
import General from "./General";
import Preview from "./Preview";
import CustomContent from "./CustomContent";
import Products from "./Products";

export default {
  name: "QuotationModal",
  filters: filters,
  components: {
    "generic-modal": GenericModal,
    General,
    Products,
    Preview,
    CustomContent,
  },
  computed: {
    preview() {
      let vm = this;
      if (vm.quotation) {
        return "";
      } else {
        return "?";
      }
    },
    footer_buttons() {
      return [];
    },
  },
  props: { quotation_in: Object },
  data() {
    return {
      quotation: {},
      quotation_setup: undefined,
    };
  },
  methods: {
    finished() {
      let vm = this;
      return new Promise(function(resolve, reject) {
        let isValid = vm.$refs.general.isValid();

        if (!isValid) reject();
        else {
          local_api(vm, "post", "/quotation/do-save", {
            i: vm.quotation.uuid || null,
            s: {
              general: vm.$refs.general.getData(),
              products: vm.$refs.products.get_product_list(),
              custom: vm.$refs.custom_content.getData(),
            },
          })
            .then((quotation) => {
              quotation.ctm_customer = undefined;
              vm.$emit("succedded", quotation);
              resolve();
            })
            .catch((err) => {
              reject(err);
            });
        }
      });
    },
    destroy() {
      this.$emit("destroy");
      this.$destroy();
    },
    remove() {
      let vm = this;
      vm.$alertify.confirm(
        vm.$t("are you sure to remove quotation?"),
        function() {
          local_api(vm, "post", "/robot/do-remove", {
            u: vm.quotation_in.uuid,
          })
            .then(() => {
              vm.$emit("deleted", vm.quotation_in);
            })
            .catch((err) => {
              vm.$alertify.error(stringify(err));
            });
        },
      );
    },
    update_custom(custom_fields) {
      this.$refs.preview.update_custom(custom_fields);
    },
    update_preview() {
      let data = this.$refs.custom_content.getData();
      this.$refs.preview.update_values(data);
    },
  },
  beforeMount() {
    let vm = this;
    if (vm.quotation_in && vm.quotation_in.uuid) {
      vm.quotation = cloneDeep(vm.quotation_in);
    }
  },
  created() {
    let vm = this;
    local_api(vm, "post", "/quotation/do-get-configuration", {})
      .then((conf) => {
        if (conf) {
          let stp = JSON.parse(conf.setup);
          vm.quotation_setup = stp;
        }
      })
      .catch((err) => {
        error_toast(stringify(err));
      });
  },
  mounted() {
    let vm = this;

    window
      .jQuery(vm.$refs.tabs)
      .find(".item")
      .tab({
        onLoad(tabPath) {
          if (tabPath == "preview") {
            if (
              vm.quotation &&
              vm.quotation.setup &&
              vm.quotation.setup.general &&
              vm.quotation.setup.general.template &&
              vm.quotation_setup
            ) {
              let templateId = vm.quotation.setup.general.template;
              let trgtTemplate = vm.quotation_setup.billing_templates.find(
                (t) => {
                  return t.id == templateId;
                },
              );
              if (trgtTemplate) {
                vm.$refs.preview.render(trgtTemplate.template);
              } else {
                console.log("wtf template");
              }
            } else {
              vm.$refs.preview.render({
                html: `<h3><i class="angle double left icon"></i>${vm.$t(
                  "module not configured yet",
                )}<i class="angle double right icon"></i></h3>`,
                css: "",
                js: "",
              });
            }
          } else if (tabPath == "custom") {
            if (
              vm.quotation &&
              vm.quotation.setup &&
              vm.quotation.setup.general &&
              vm.quotation.setup.general.template &&
              vm.quotation_setup
            ) {
              let templateId = vm.quotation.setup.general.template;
              let trgtTemplate = vm.quotation_setup.billing_templates.find(
                (t) => {
                  return t.id == templateId;
                },
              );
              if (trgtTemplate) {
                vm.$refs.custom_content.render(trgtTemplate.template);
              } else {
                console.log("wtf template");
              }
            } else {
              vm.$refs.custom_content.render({
                html: `<h3><i class="angle double left icon"></i>${vm.$t(
                  "module not configured yet",
                )}<i class="angle double right icon"></i></h3>`,
                css: "",
                js: "",
              });
            }
          }
        },
      });
  },
};
</script>
